module.exports = __webpack_public_path__ + "static/media/1.b055ea38.png";